import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { WeightOptionType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

const WeightOptionTypeSelect = ({ value, onChange, disabled }: Omit<SelectProps<WeightOptionType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(WeightOptionType)}
			getOptionLabel={option => intl.formatMessage({ id: `WEIGHT_OPTION_${option}` })}
			value={value}
			disabled={disabled}
			onChange={onChange}
			disableSearch />
	);
};

export default WeightOptionTypeSelect;
